import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { mockSchoolYears } from './school-years.mock';

export const mockSchoolYearsRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.SCHOOL_YEARS)) {
        const response: any = {
            status: 200,
            body: mockSchoolYears,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
